function ReactTransformTenchmark(options) {
  return function wrap(ReactClass, uniqueId) {
    //获取类名
    var displayName = options.components[uniqueId].displayName || ReactClass.name;
    
    var componentWillMount = ReactClass.prototype.componentWillMount;
    ReactClass.prototype.componentWillMount = function() {
      window.iTalentPMS && window.iTalentPMS.addComponent && window.iTalentPMS.addComponent(displayName, 'render', 'start');
      if (ReactClass.splashAction && window.iTalentPMS && window.iTalentPMS.setCurrent) {
        window.iTalentPMS.setCurrent('splashAction', ReactClass.splashAction);
      }
      if (componentWillMount) {
        componentWillMount.apply(this, arguments);
      }
    };

    var componentDidMount = ReactClass.prototype.componentDidMount;
    ReactClass.prototype.componentDidMount = function() {
      window.iTalentPMS && window.iTalentPMS.addComponent && window.iTalentPMS.addComponent(displayName, 'render', 'end');
      if (componentDidMount) {
        componentDidMount.apply(this, arguments);
      }
    };

    var componentWillUpdate = ReactClass.prototype.componentWillUpdate;
    ReactClass.prototype.componentWillUpdate = function() {
      window.iTalentPMS && window.iTalentPMS.addComponent && window.iTalentPMS.addComponent(displayName, 'reRender', 'start');

      if (componentWillUpdate) {
        componentWillUpdate.apply(this, arguments);
      }
    };

    var componentDidUpdate = ReactClass.prototype.componentDidUpdate;
    ReactClass.prototype.componentDidUpdate = function() {
      if (window.iTalentPMS) {
        window.iTalentPMS.addComponent && window.iTalentPMS.addComponent(displayName, 'reRender', 'end');
        if (window.iTalentPMS.getCurrent) {
        //if(name.toLowerCase() === 'app' && window.iTalentPMS.getCurrent){
          var currentAction = window.iTalentPMS.getCurrent('Action') || {};
          var type = currentAction.type || '';
          if (window.iTalentPMS.getCurrent('splashAction') ===  type) {
            window.iTalentPMS.addPath && window.iTalentPMS.addPath('splash', 'splash', 'end');
          }
          if (currentAction.isAjax) {
            var last = type.indexOf("_")!= -1 ? type.match(/.*_/)[0].lastIndexOf("_") : "";
            type = last ? type.slice(0, last) : type;
          }
          window.iTalentPMS.addAction && window.iTalentPMS.addAction(type, 'end');
        }
        window.iTalentPMS.addComponent && window.iTalentPMS.addComponent(displayName, 'update', 'end');
      }

      if (componentDidUpdate) {
        componentDidUpdate.apply(this, arguments);
      }
    };

    return ReactClass;
  };
}

// window['@beisen/ReactTransformTenchmark'] = ReactTransformTenchmark;
export default ReactTransformTenchmark;